"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const logisticTripControlPointsService = {
  updateTripControlPointAlarm: function (options) {
    return api.put("/TripRouteControlPoints/Alarm", options, WithToken.headersToken({}, configuration.cookieName));
  },
  updateTripControlPointVariation: function (options) {
    return api.put("/TripRouteControlPoints/Variation", options, WithToken.headersToken({}, configuration.cookieName));
  },
};

export default logisticTripControlPointsService;
